// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * STYLES FOR THE UC DAVIS CAMPUS THEME
 * DEPENDENT ON FELLOW CSS CUSTOM PROPERTIES FILE
*/
body, html {
  font-family      : proxima-nova,"Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size        : 16px;
  font-weight      : var(--fw-html);
  line-height      : var(--lh-html);
  margin           : 0;
  padding          : 0;
  background-color : var(--color-white);
  color            : var(--color-html);
  max-width        : 100vw;
  overflow-x: hidden;
}

/* body {
  position: relative;
} */
h5 {
  font-size: 1rem;
}

@media screen and (min-width: 768px) {
  body, html {
    font-size: calc(16px + 14 * ((100vw - 768px) / 3072));
  }
  h1 {
    font-size: 2.94rem;
    font-weight: 700;
  }
  h2 {
    font-size: 2.0995rem;
  }
  h3 {
    font-size: 1.7425rem;
  }
  h4 {
    font-size: 1.428rem;
  }
  h5 {
    font-size: 1.207rem;
  }
  h6 {
    font-size: 1rem;
  }
}
@media screen and (min-width: 3840px) {
  body, html {
    font-size: 30px;
  }
}

/* BASIC TYPOGRAPHY */
p, .p {
  /* font-size: var(--fs-p); */
  font-weight: var(--fw-p);
  line-height: var(--lh-p);
  color: var(--color-p);
}

/* HEADINGS */
h1, .h1 {
  /* font-size: var(--fs-h1); */
  /* font-weight: var(--fw-h1); */
  /* font-size: 1.91rem; */
  color: var(--color-h1);
  line-height: var(--lh-h1);
}
h2, .h2 {
  /* font-size: var(--fs-h2); */
  /* font-weight: var(--fw-h2); */
  /* font-size: 1.6055rem; */
  color: var(--color-h2);
  line-height: var(--lh-h2);
}
h3, .h3 {
  /* font-size: var(--fs-h3); */
  /* font-weight: var(--fw-h3); */
  /* font-size: 1.3325rem; */
  color: var(--color-h3);
  line-height: var(--lh-h3);
}
h4, .h4 {
  /* font-size: var(--fs-h4); */
  /* font-weight: var(--fw-h4); */
  /* font-weight: 1.092rem; */
  color: var(--color-h4);
  line-height: var(--lh-h4);
}
h5, .h5 {
  /* font-size: var(--fs-h5); */
  /* font-weight: var(--fw-h5); */
  /* font-weight: 1rem; */
  color: var(--color-h5);
  line-height: var(--lh-h5);
}
h6, .h6 {
  /* font-size: var(--fs-h6); */
  /* font-weight: var(--fw-h6); */
  color: var(--color-h6);
  line-height: var(--lh-h6);
}
h1.color-light, .h1.color-light {
  color: var(--color-h1-light);
}
h2.color-light, .h2.color-light {
  color: var(--color-h2-light);
}
h3.color-light, .h3.color-light {
  color: var(--color-h3-light);
}
h4.color-light, .h4.color-light {
  color: var(--color-h4-light);
}
h5.color-light, .h5.color-light {
  color: var(--color-h5-light);
}
h6.color-light, .h6.color-light {
  color: var(--color-h6-light);
}

/* LINKS */
a {
  color: var(--color-a);
}
a:visited {
  /* color: var(--color-a-visited); */
}
a:hover {
  color: var(--color-a-hover);
}
a:active {
  color: var(--color-a-active);
}
a:focus {
  color: var(--color-a-focus);
}
h1 > a, .h1 > a,
h2 > a, .h2 > a,
h3 > a, .h3 > a,
h4 > a, .h4 > a,
h5 > a, .h5 > a,
h6 > a, .h6 > a {
  text-decoration: underline;
  color: inherit;
}
h1 > a:hover, .h1 > a:hover,
h2 > a:hover, .h2 > a:hover,
h3 > a:hover, .h3 > a:hover,
h4 > a:hover, .h4 > a:hover,
h5 > a:hover, .h5 > a:hover,
h6 > a:hover, .h6 > a:hover {
  text-decoration: none;
  color: inherit;
}
h1 > a:active, .h1 > a:active,
h2 > a:active, .h2 > a:active,
h3 > a:active, .h3 > a:active,
h4 > a:active, .h4 > a:active,
h5 > a:active, .h5 > a:active,
h6 > a:active, .h6 > a:active {
  text-decoration: none;
  color: inherit;
}
h1 > a:focus, .h1 > a:focus,
h2 > a:focus, .h2 > a:focus,
h3 > a:focus, .h3 > a:focus,
h4 > a:focus, .h4 > a:focus,
h5 > a:focus, .h5 > a:focus,
h6 > a:focus, .h6 > a:focus {
  text-decoration: none;
  color: inherit;
}
/* h1 > a:visited, .h1 > a:visited,
h2 > a:visited, .h2 > a:visited,
h3 > a:visited, .h3 > a:visited,
h4 > a:visited, .h4 > a:visited,
h5 > a:visited, .h5 > a:visited,
h6 > a:visited, .h6 > a:visited {
  text-decoration: underline;
} */

/* */
[hidden] {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./public/elements/styles/campus-theme.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,2EAA2E;EAC3E,uBAAuB;EACvB,iCAAiC;EACjC,iCAAiC;EACjC,oBAAoB;EACpB,oBAAoB;EACpB,qCAAqC;EACrC,oCAAoC;EACpC,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;GAEG;AACH;EACE,eAAe;AACjB;;AAEA;EACE;IACE,qDAAqD;EACvD;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,qBAAqB;AACvB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;AACA;;;;;;EAME,0BAA0B;EAC1B,cAAc;AAChB;AACA;;;;;;EAME,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;;EAME,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;;EAME,qBAAqB;EACrB,cAAc;AAChB;AACA;;;;;;;GAOG;;AAEH,IAAI;AACJ;EACE,wBAAwB;AAC1B","sourcesContent":["/*\n * STYLES FOR THE UC DAVIS CAMPUS THEME\n * DEPENDENT ON FELLOW CSS CUSTOM PROPERTIES FILE\n*/\nbody, html {\n  font-family      : proxima-nova,\"Helvetica Neue\",Helvetica,Arial,sans-serif;\n  font-size        : 16px;\n  font-weight      : var(--fw-html);\n  line-height      : var(--lh-html);\n  margin           : 0;\n  padding          : 0;\n  background-color : var(--color-white);\n  color            : var(--color-html);\n  max-width        : 100vw;\n  overflow-x: hidden;\n}\n\n/* body {\n  position: relative;\n} */\nh5 {\n  font-size: 1rem;\n}\n\n@media screen and (min-width: 768px) {\n  body, html {\n    font-size: calc(16px + 14 * ((100vw - 768px) / 3072));\n  }\n  h1 {\n    font-size: 2.94rem;\n    font-weight: 700;\n  }\n  h2 {\n    font-size: 2.0995rem;\n  }\n  h3 {\n    font-size: 1.7425rem;\n  }\n  h4 {\n    font-size: 1.428rem;\n  }\n  h5 {\n    font-size: 1.207rem;\n  }\n  h6 {\n    font-size: 1rem;\n  }\n}\n@media screen and (min-width: 3840px) {\n  body, html {\n    font-size: 30px;\n  }\n}\n\n/* BASIC TYPOGRAPHY */\np, .p {\n  /* font-size: var(--fs-p); */\n  font-weight: var(--fw-p);\n  line-height: var(--lh-p);\n  color: var(--color-p);\n}\n\n/* HEADINGS */\nh1, .h1 {\n  /* font-size: var(--fs-h1); */\n  /* font-weight: var(--fw-h1); */\n  /* font-size: 1.91rem; */\n  color: var(--color-h1);\n  line-height: var(--lh-h1);\n}\nh2, .h2 {\n  /* font-size: var(--fs-h2); */\n  /* font-weight: var(--fw-h2); */\n  /* font-size: 1.6055rem; */\n  color: var(--color-h2);\n  line-height: var(--lh-h2);\n}\nh3, .h3 {\n  /* font-size: var(--fs-h3); */\n  /* font-weight: var(--fw-h3); */\n  /* font-size: 1.3325rem; */\n  color: var(--color-h3);\n  line-height: var(--lh-h3);\n}\nh4, .h4 {\n  /* font-size: var(--fs-h4); */\n  /* font-weight: var(--fw-h4); */\n  /* font-weight: 1.092rem; */\n  color: var(--color-h4);\n  line-height: var(--lh-h4);\n}\nh5, .h5 {\n  /* font-size: var(--fs-h5); */\n  /* font-weight: var(--fw-h5); */\n  /* font-weight: 1rem; */\n  color: var(--color-h5);\n  line-height: var(--lh-h5);\n}\nh6, .h6 {\n  /* font-size: var(--fs-h6); */\n  /* font-weight: var(--fw-h6); */\n  color: var(--color-h6);\n  line-height: var(--lh-h6);\n}\nh1.color-light, .h1.color-light {\n  color: var(--color-h1-light);\n}\nh2.color-light, .h2.color-light {\n  color: var(--color-h2-light);\n}\nh3.color-light, .h3.color-light {\n  color: var(--color-h3-light);\n}\nh4.color-light, .h4.color-light {\n  color: var(--color-h4-light);\n}\nh5.color-light, .h5.color-light {\n  color: var(--color-h5-light);\n}\nh6.color-light, .h6.color-light {\n  color: var(--color-h6-light);\n}\n\n/* LINKS */\na {\n  color: var(--color-a);\n}\na:visited {\n  /* color: var(--color-a-visited); */\n}\na:hover {\n  color: var(--color-a-hover);\n}\na:active {\n  color: var(--color-a-active);\n}\na:focus {\n  color: var(--color-a-focus);\n}\nh1 > a, .h1 > a,\nh2 > a, .h2 > a,\nh3 > a, .h3 > a,\nh4 > a, .h4 > a,\nh5 > a, .h5 > a,\nh6 > a, .h6 > a {\n  text-decoration: underline;\n  color: inherit;\n}\nh1 > a:hover, .h1 > a:hover,\nh2 > a:hover, .h2 > a:hover,\nh3 > a:hover, .h3 > a:hover,\nh4 > a:hover, .h4 > a:hover,\nh5 > a:hover, .h5 > a:hover,\nh6 > a:hover, .h6 > a:hover {\n  text-decoration: none;\n  color: inherit;\n}\nh1 > a:active, .h1 > a:active,\nh2 > a:active, .h2 > a:active,\nh3 > a:active, .h3 > a:active,\nh4 > a:active, .h4 > a:active,\nh5 > a:active, .h5 > a:active,\nh6 > a:active, .h6 > a:active {\n  text-decoration: none;\n  color: inherit;\n}\nh1 > a:focus, .h1 > a:focus,\nh2 > a:focus, .h2 > a:focus,\nh3 > a:focus, .h3 > a:focus,\nh4 > a:focus, .h4 > a:focus,\nh5 > a:focus, .h5 > a:focus,\nh6 > a:focus, .h6 > a:focus {\n  text-decoration: none;\n  color: inherit;\n}\n/* h1 > a:visited, .h1 > a:visited,\nh2 > a:visited, .h2 > a:visited,\nh3 > a:visited, .h3 > a:visited,\nh4 > a:visited, .h4 > a:visited,\nh5 > a:visited, .h5 > a:visited,\nh6 > a:visited, .h6 > a:visited {\n  text-decoration: underline;\n} */\n\n/* */\n[hidden] {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
